export { matchers } from './matchers.js';

export const nodes = [
	() => import('./nodes/0'),
	() => import('./nodes/1'),
	() => import('./nodes/2'),
	() => import('./nodes/3'),
	() => import('./nodes/4'),
	() => import('./nodes/5'),
	() => import('./nodes/6'),
	() => import('./nodes/7'),
	() => import('./nodes/8'),
	() => import('./nodes/9'),
	() => import('./nodes/10'),
	() => import('./nodes/11'),
	() => import('./nodes/12'),
	() => import('./nodes/13'),
	() => import('./nodes/14'),
	() => import('./nodes/15'),
	() => import('./nodes/16'),
	() => import('./nodes/17'),
	() => import('./nodes/18'),
	() => import('./nodes/19'),
	() => import('./nodes/20'),
	() => import('./nodes/21'),
	() => import('./nodes/22'),
	() => import('./nodes/23'),
	() => import('./nodes/24'),
	() => import('./nodes/25'),
	() => import('./nodes/26'),
	() => import('./nodes/27'),
	() => import('./nodes/28'),
	() => import('./nodes/29'),
	() => import('./nodes/30'),
	() => import('./nodes/31'),
	() => import('./nodes/32'),
	() => import('./nodes/33'),
	() => import('./nodes/34'),
	() => import('./nodes/35'),
	() => import('./nodes/36'),
	() => import('./nodes/37'),
	() => import('./nodes/38'),
	() => import('./nodes/39'),
	() => import('./nodes/40'),
	() => import('./nodes/41'),
	() => import('./nodes/42'),
	() => import('./nodes/43'),
	() => import('./nodes/44'),
	() => import('./nodes/45'),
	() => import('./nodes/46'),
	() => import('./nodes/47'),
	() => import('./nodes/48'),
	() => import('./nodes/49'),
	() => import('./nodes/50'),
	() => import('./nodes/51'),
	() => import('./nodes/52'),
	() => import('./nodes/53'),
	() => import('./nodes/54'),
	() => import('./nodes/55'),
	() => import('./nodes/56'),
	() => import('./nodes/57'),
	() => import('./nodes/58'),
	() => import('./nodes/59'),
	() => import('./nodes/60'),
	() => import('./nodes/61'),
	() => import('./nodes/62'),
	() => import('./nodes/63'),
	() => import('./nodes/64'),
	() => import('./nodes/65'),
	() => import('./nodes/66'),
	() => import('./nodes/67'),
	() => import('./nodes/68'),
	() => import('./nodes/69'),
	() => import('./nodes/70'),
	() => import('./nodes/71'),
	() => import('./nodes/72'),
	() => import('./nodes/73')
];

export const server_loads = [];

export const dictionary = {
		"/": [4],
		"/404": [5],
		"/about": [6],
		"/armenian-church-origin": [7],
		"/articles": [8],
		"/articles/[id]": [9],
		"/auth/callback": [10],
		"/community/acyoa-juniors": [11],
		"/community/adult-choir": [12],
		"/community/altar-servers": [13],
		"/community/chess-club": [14],
		"/community/cultural-committee": [15],
		"/community/kirikian-armenian-school": [16],
		"/community/parish-council": [17],
		"/community/sunday-school": [18],
		"/community/youth-orchestra": [19],
		"/contact": [20],
		"/events": [21],
		"/events/[id]": [22],
		"/faith": [23],
		"/faith/feast-days": [24],
		"/faith/feast-days/ascension": [25],
		"/faith/feast-days/assumption": [26],
		"/faith/feast-days/christmas-day": [27],
		"/faith/feast-days/christmas-eve": [28],
		"/faith/feast-days/easter": [29],
		"/faith/feast-days/exaltation-of-the-cross": [30],
		"/faith/feast-days/fasting": [31],
		"/faith/feast-days/forty-martyrs": [32],
		"/faith/feast-days/great-lent": [33],
		"/faith/feast-days/holy-friday": [34],
		"/faith/feast-days/holy-monday": [35],
		"/faith/feast-days/holy-saturday": [36],
		"/faith/feast-days/holy-thursday": [37],
		"/faith/feast-days/holy-tuesday": [38],
		"/faith/feast-days/holy-wednesday": [39],
		"/faith/feast-days/holy-week": [40],
		"/faith/feast-days/hripsimian-saints": [41],
		"/faith/feast-days/mid-lent": [42],
		"/faith/feast-days/nevarsag": [43],
		"/faith/feast-days/palm-sunday": [44],
		"/faith/feast-days/pentecost": [45],
		"/faith/feast-days/poon-paregentan": [46],
		"/faith/feast-days/presentation-of-the-lord": [47],
		"/faith/feast-days/st-etchmiadzin": [48],
		"/faith/feast-days/st-gregory": [49],
		"/faith/feast-days/st-leontius": [50],
		"/faith/feast-days/st-sarkis": [51],
		"/faith/feast-days/st-vartan-speech": [53],
		"/faith/feast-days/st-vartan": [52],
		"/faith/feast-days/transfiguration": [54],
		"/faith/feast-days/why-january-6": [55],
		"/faith/saints": [56],
		"/gallery": [57],
		"/gallery/[slug]": [58],
		"/install": [59],
		"/login": [60],
		"/members": [61,[2]],
		"/members/parish-council": [62,[2,3]],
		"/members/parish-council/events/new": [63,[2,3]],
		"/members/parish-council/video-streaming": [64,[2,3]],
		"/pastor": [65],
		"/patron-saint": [66],
		"/services": [67],
		"/services/anointing-of-the-sick": [68],
		"/services/baptism": [69],
		"/services/bequests": [70],
		"/services/requiem": [71],
		"/services/wedding": [72],
		"/watch": [73]
	};

export const hooks = {
	handleError: (({ error }) => { console.error(error) }),
	
	reroute: (() => {}),
	transport: {}
};

export const decoders = Object.fromEntries(Object.entries(hooks.transport).map(([k, v]) => [k, v.decode]));
export const encoders = Object.fromEntries(Object.entries(hooks.transport).map(([k, v]) => [k, v.encode]));

export const hash = false;

export const decode = (type, value) => decoders[type](value);

export { default as root } from '../root.js';